import z from 'zod';

export type SimpleMediaDto = {
	id: string;
	url: string;
	availableSizes: number[];
};

export const SimpleMediaDtoSchema: z.ZodType<SimpleMediaDto> = z.object({
	id: z.string(),
	url: z.string(),
	availableSizes: z.number().array(),
});
